import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import type { TaskQueue } from "@/app/services/generated/taskqueueService";
import { taskQueueService } from "@/app/services/generated/taskqueueService";

export interface IHasTaskQueuesCache {
  taskQueues: TaskQueuesCache;
}

// Singleton cache store
const taskQueuesCacheStore = new EntityCacheStore<TaskQueue>(
  EnumCacheEntityType.taskQueue,
  async () => taskQueueService.getAllTaskQueues()
);

// Ephemeral reader
export default class TaskQueuesCache extends EntityWithGuidKeyCache<TaskQueue> {
  constructor() {
    super(taskQueuesCacheStore, (x) => x.id);
  }
}
